module.exports = __webpack_public_path__ + "static/assets/a327fb11a1970ebc3d5931b49b64b0ad.svg";